<template>
    <div>
        <b-form-row>
            <b-col>
                <b-form-group label="Cardholder Id">
                    <b-form-input v-model="patientPlan.cardholderId"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Group Id">
                    <b-form-input v-model="patientPlan.groupId"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group label="Person Code">
                    <b-form-input v-model="patientPlan.personCode"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col>
                <EnumSelector label="Relationship Code"
                              v-model="patientPlan.relationshipCode"
                              :enumCodes="relationshipCodes"></EnumSelector>
            </b-col>
        </b-form-row>
        <b-form-row>
            <b-col cols="6" md="3">
                <b-form-group label="DOB Override"
                              description="When set, this date is sent to insurance in place of the patient's date of birth.">
                    <b-form-datepicker v-model="patientPlan.dateOfBirthOverride"
                                       reset-button
                                       :reset-value="null"
                                       placeholder="No override"></b-form-datepicker>
                </b-form-group>
            </b-col>
            <b-col cols="6" md="5">
                <b-form-group description="When set, this eligibility override is sent to insurance on every claim billed against this plan.">
                    <EnumSelector label="Eligibility Clarification Code"
                                  v-model="patientPlan.eligibilityClarificationCode"
                                  :enumCodes="eligibilityClarificationCodes"
                                  :elementsToDiscard="discardedEligibilityClarificationCodes"
                                  clearable></EnumSelector>
                </b-form-group>
            </b-col>
        </b-form-row>
    </div>
</template>

<script lang="ts">
    import Component from "vue-class-component";
    import {Vue, VModel} from "vue-property-decorator";
    import {EligibilityClarificationCode, PatientPlan, RelationshipCode} from "@/models/PatientPlan";
    import EnumSelector from "@/components/EnumSelector.vue";

    @Component({
        components: {
            EnumSelector,
        }
    })
    export default class PatientPlanEditComponent extends Vue {
        @VModel() private patientPlan!: PatientPlan;
        readonly relationshipCodes = RelationshipCode;
        readonly eligibilityClarificationCodes = EligibilityClarificationCode;
        // Clearing the selector is how "no override" is expressed; an explicit 0 would be transmitted.
        readonly discardedEligibilityClarificationCodes = [EligibilityClarificationCode.NotSpecified];

    }
</script>

<style scoped>
</style>
